(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    var closeBtn = document.getElementById('cart-close');
    var itemsEl = document.getElementById('cart-items');
    var footerEl = document.getElementById('cart-footer');
    var cartIcon = document.getElementById('cart-icon');

    if (!drawer) return;

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function sizedImageUrl(url, width, height) {
      if (!url) return url;
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'width=' + width + '&height=' + height;
    }

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      drawer.inert = false;
      document.body.classList.add('cart-open');
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      document.body.classList.remove('cart-open');
    }

    function renderCart(cart) {
      if (cartIcon) {
        cartIcon.src = cart.item_count > 0 ? cartIcon.dataset.fullSrc : cartIcon.dataset.emptySrc;
      }

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        footerEl.innerHTML = '';
        return;
      }

      itemsEl.innerHTML = cart.items.map(function (item) {
        var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-item__variant">' + item.variant_title + '</p>'
          : '';
        return '<div class="cart-item">'
          + '<a href="' + item.url + '" class="cart-item__image-link">'
          + '<img src="' + sizedImageUrl(item.image, 144, 216) + '" alt="' + item.product_title + '" class="cart-item__image" width="72" height="108">'
          + '</a>'
          + '<div class="cart-item__details">'
          + '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>'
          + variantLine
          + '<div class="cart-item__bottom">'
          + '<div class="cart-item__qty">'
          + '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">&#8722;</button>'
          + '<span class="cart-item__qty-count">' + item.quantity + '</span>'
          + '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity">&#43;</button>'
          + '</div>'
          + '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>'
          + '</div>'
          + '<button class="cart-item__remove" data-key="' + item.key + '">Remove</button>'
          + '</div>'
          + '</div>';
      }).join('');

      footerEl.innerHTML = '<div class="cart-drawer__subtotal">'
        + '<span>Subtotal</span>'
        + '<span>' + formatMoney(cart.total_price) + '</span>'
        + '</div>'
        + '<a href="/checkout" class="cart-drawer__checkout">Check out</a>';
    }

    function fetchCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }

    function addToCart(formData) {
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) {
          if (!r.ok) throw new Error('Could not add to cart');
          return r.json();
        })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          renderCart(cart);
          openDrawer();
        });
    }

    function changeQuantity(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cart-form]');
      if (!form) return;
      e.preventDefault();
      addToCart(new FormData(form));
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        fetchCart().then(function (cart) {
          renderCart(cart);
          openDrawer();
        });
      }

      var qtyBtn = e.target.closest('.cart-item__qty-btn');
      if (qtyBtn) {
        var key = qtyBtn.dataset.key;
        var delta = parseInt(qtyBtn.dataset.delta, 10);
        var countEl = qtyBtn.parentElement.querySelector('.cart-item__qty-count');
        var current = parseInt(countEl.textContent, 10);
        var next = current + delta;
        if (next < 1) next = 0;
        changeQuantity(key, next);
      }

      if (e.target.closest('.cart-item__remove')) {
        changeQuantity(e.target.closest('.cart-item__remove').dataset.key, 0);
      }
    });

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
